import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuardService, RoleGuardService } from '../authentication/service/auth-guard.service';
import { WorkerDashboardComponent } from './worker-dashboard/worker-dashboard.component';
import { WorkerSafetyboxComponent } from './worker-safetybox/worker-safetybox.component';
import { TimesheetsComponent } from './timesheets/timesheets.component';
import { WorkerRegistrationComponent } from './worker-registration/worker-registration.component';

const routes: Routes = [
  {
    path: 'worker/dashboard',
    component: WorkerDashboardComponent,
    canActivate: [RoleGuardService],
    data: {
      expectedRole: ['worker', 'sub_supplier']
    }
  },
  {
    path: 'worker/safetybox',
    component: WorkerSafetyboxComponent,
    canActivate: [RoleGuardService],
    data: {
      expectedRole: ['worker', 'sub_supplier']
    }
  },
  {
    path: 'worker/timesheets',
    component: TimesheetsComponent,
    canActivate: [RoleGuardService],
    data: {
      expectedRole: ['worker', 'sub_supplier']
    }
  },
  {
    path: 'worker/registration/:token',
    component: WorkerRegistrationComponent
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class WorkerRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/worker/worker-routing.module.ts